import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CdsAnnouncerService } from '@citi-gcg-173875/citi-common-ui-cds';


@Component({
  selector: 'li[mkt-accordion-section]',
  templateUrl: './mkt-accordion-section.component.html',
  styleUrls: ['./mkt-accordion-section.component.scss'],
  standalone: false
})
export class MktAccordionSectionComponent {

  public sectionIndex: number;
  /**
   * @property isCustomSectionHeaderRequired
   * @description Allows overriding the section title
   * Default behavior is false - which means input 'sectionTitle' will be displayed
   * @twoway false
   */
  @Input() isCustomSectionHeaderRequired: boolean = false;

  /**
   * @property disabled
   * @description disables the click event on the accordian section
   */
  @Input() disabled: boolean = false;

  /**
   * @property id
   * @description This attribute sets the HTML ID for the expanding content area and the value of the
   * aria-controls attribute
   * @return string
   */
  @Input() idStr: string = null;

  /**
   * @property title
   * @description The title displayed to the right of the up/down arrow
   * @return string
   */
  @Input() sectionTitle: string;

  /**
   * @property summary
   * @description The text displayed below the up/down arrow and the title. Always displayed.
   * @return string
   */
  @Input() summary: string;

  /**
   * @property htmlContent
   * @description Adds the given string as the content and supports simple HTML.
   * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
   * This works with expressions for asynchronously loaded content that will get picked up by the Angular 2 change detection.
   * @return string
   * @twoway false
   */
  @Input() htmlContent: string;

  /**
   * @property headingLevel
   * @description Sets the aria-level property for the accordion heading button. (Default: 3)
   * @return string
   * @twoway false
   */
  @Input() headingLevel: number = 3;

  /**
   * @property sectionClicked
   * @description emits when the section button is clicked
   * @twoway false
   */
  @Output() sectionClicked: EventEmitter<number> = new EventEmitter();

  /**
   * @property isOpen
   * @description Checks if the current accordion section is openend/expanded
   * @twoway false
   */
  public _isOpen: boolean = false;
  @Input()
  set isOpen(isOpen: boolean) {
    // if (this.isAndroidDevice) this.announcer.announce(`${isOpen ? 'expanded' : 'collapse'}`);
    this.isExpanded = this._isOpen = isOpen;
  }
  get isOpen() {
    return this._isOpen;
  }

  get isAndroidDevice(): boolean {
    if (!navigator || !navigator.userAgent) return false;
    else return /(android)/i.test(navigator.userAgent);
  }

  @ViewChild('button') button: ElementRef;

  @HostBinding('class.parent') cssClassParent: boolean = false;
  @HostBinding('class.level1') cssClassLevel1: boolean = false;
  @HostBinding('attr.role') attributeRole: string = null;
  @HostBinding('class.is-expanded') isExpanded: boolean = false;


  constructor(private announcer: CdsAnnouncerService) {}

  focusButton() {
    this.button.nativeElement.focus()
  }
}
